/* 已經上線的列傳：其他列傳在選單上只顯示預告（不能開章，伺服器也不發那些章的星數黃金）
 * OPEN_CHAPTERS 要和 index.ts 裡這些列傳的章節一致（tests/campaign_open.cjs 檢查）。
 * 開發時在瀏覽器 console 打 localStorage.setItem('sg-campaign-dev', '1') 就能開全部的章。 */
// @ts-nocheck
export const OPEN_LISTS = ['sunwu'];
export const OPEN_CHAPTERS = [
  'sunjian-1', 'sunwu-3', 'sunwu-4',
  'sunwu-5', 'sunwu-6', 'sunwu-7', 'sunwu-8', 'sunwu-9',
  'sunwu-10', 'sunwu-11', 'sunwu-12', 'sunwu-14',
  'sunwu-15', 'sunwu-16', 'sunwu-17', 'sunwu-18',
];
const dev = () => { try { return localStorage.getItem('sg-campaign-dev') === '1'; } catch (e) { return false; } };
export const listOpen = (id) => OPEN_LISTS.includes(id) || dev();
// 分幕的後幾幕（of）跟著第一幕那章
export const chapterOpen = (chapters, id) => { const d = chapters[id]; return !!d && (OPEN_CHAPTERS.includes(d.of || id) || dev()); };
